import { httpRequest } from "@/utils/HttpRequest";
import { IPage, ISearchPage } from "@/types/FmsTypes";

//详情
export interface IAcctUnitDetail {
    id: string,
    address: string,
    bentity: string,
    bentityList: string,
    branch: string,
    branchList: string,
    code: string,
    contact: string,
    createTime: string,
    createUser: string,
    deleteFlag: string,
    enable: string,
    name: string,
    note: string,
    phone: string,
    shop: string,
    shopCode: string,
    shopList: string,
    shopName: string,
    status: string,
    tel: string,
    updateTime: string,
    updateUser: string,
    ver: string,
}
//新增
export interface IAcctUnitInsert {
    "sourceApp"?: string,   // "fms",
    "shopCode"?: string,   // "64eec0c1d6f37078b6b460e4cb0ac9d7",
    "shopName"?: string,   // 1,
    "name"?: string,   // "王氏集团",
    "contact"?: string,   // "杨月",
    "phone"?: string,   // "153000000",
    "tel"?: string,   // "41515",
    "address"?: string,   // "北京大学",
    "shop"?: string,   // "a17fe0959754f55f0fcb1604f81ad814,b34262a08ce4d963a9b42ae32e1e08bd",
    "betity"?: string,   // "768459d2960ef3484ea8f1334c56459a,81c06bb055d3e22aa0d7b39374842d67",
    "note"?: string,   // "备注"
    "createUser"?: string,   // "备注"
}

//编辑
export interface IAcctUnitUpdate extends IAcctUnitInsert {
    id: string,
}
//搜索条件
export interface IAcctUnitSearchFields {
    bentity?: string,   // "",
    shop?: string,   // "a17fe0959754f55f0fcb1604f81ad814",
    name?: string,
    status?: string,
}

export interface IAcctUnitSearch
    extends IAcctUnitSearchFields, ISearchPage {

}

//表单字段
export interface IAcctUnitFormFields extends IAcctUnitUpdate {

}

class AcctUnitService {
    async page(searchVo: IAcctUnitSearch, config: object = {}) {
        const apiUrl = "/md/accountUnit/page";
        return await httpRequest.post<IPage<IAcctUnitDetail>>(apiUrl, searchVo, config);
    }
    async one(obj: { code: string }) {
        const apiUrl = `/md/accountUnit/one`;
        return await httpRequest.post<IAcctUnitDetail>(apiUrl, obj);
    }
    async insert(insertVo: IAcctUnitInsert) {
        const apiUrl = "/md/accountUnit/insert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async update(updateVo: IAcctUnitUpdate) {
        const apiUrl = "/md/accountUnit/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //启用禁用
    async disable(obj: { code: string, status: number }) {
        const apiUrl = `/md/accountUnit/disable`;
        return await httpRequest.post<boolean>(apiUrl, obj);
    }
}

export const acctUnitService = new AcctUnitService();
